// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Form$MakerDs from "maker-ds/src/Form.bs.mjs";
import * as Input$MakerDs from "maker-ds/src/Input.bs.mjs";
import * as Query$MakerDs from "maker-ds/src/Query.bs.mjs";
import * as Button$MakerDs from "maker-ds/src/Button.bs.mjs";
import * as Select$MakerDs from "maker-ds/src/Select.bs.mjs";
import * as Layout$FeedSync from "./Layout.bs.mjs";
import * as API_Result$MakerDs from "maker-ds/src/api/API_Result.bs.mjs";
import * as ClientAPI$FeedSync from "./ClientAPI.bs.mjs";
import * as ErrorPage$FeedSync from "./ErrorPage.bs.mjs";
import * as MonitoringPage$FeedSync from "./MonitoringPage.bs.mjs";

function getCurrencies(settings) {
  var match = settings.currencies.length;
  if (match !== 0) {
    return settings.currencies;
  } else {
    return [[
              "",
              {
                TAG: /* CSVFeed */1,
                _0: ""
              }
            ]];
  }
}

function SettingsPage$Show(Props) {
  var initialSettings = Props.initialSettings;
  var mutateSnapshotHistory = Props.mutateSnapshotHistory;
  var mutateSettings = Props.mutateSettings;
  var match = React.useState(function () {
        return initialSettings;
      });
  var setSettings = match[1];
  var settings = match[0];
  var saveDisabled = Caml_obj.equal(settings, initialSettings);
  var onSubmitAsync = function (feedback) {
    return Curry._1(feedback, API_Result$MakerDs.Result.flatMapAsync(API_Result$MakerDs.Result.flatMapAsync(ClientAPI$FeedSync.updateSettings(settings), (function (result) {
                          return API_Result$MakerDs.Result.map(API_Result$MakerDs.Result.make(Curry._2(mutateSnapshotHistory, (function (b) {
                                                return b;
                                              }), true)), (function (param) {
                                        return result;
                                      }));
                        })), (function (result) {
                      return API_Result$MakerDs.Result.map(API_Result$MakerDs.Result.make(Curry._2(mutateSettings, (function (b) {
                                            return settings;
                                          }), true)), (function (param) {
                                    return result;
                                  }));
                    })));
  };
  console.log("settings", settings);
  var renderCurrencyFeedSection = function (index, param) {
    var feed = param[1];
    var currency = param[0];
    var setCurrencySettings = function (fn) {
      Curry._1(setSettings, (function (current) {
              return {
                      userId: current.userId,
                      supplementaryFeed: current.supplementaryFeed,
                      currencies: Belt_Array.concatMany([
                            getCurrencies(current).slice(0, index),
                            Belt_Option.mapWithDefault(Belt_Array.get(getCurrencies(current), index), [Curry._1(fn, [
                                        currency,
                                        feed
                                      ])], (function (item) {
                                    return [Curry._1(fn, item)];
                                  })),
                            getCurrencies(current).slice(index + 1 | 0)
                          ]),
                      autoSync: current.autoSync
                    };
            }));
    };
    var url = Belt_Option.getWithDefault(feed._0, "");
    var formatValue;
    switch (feed.TAG | 0) {
      case /* XMLFeed */0 :
          formatValue = "XML";
          break;
      case /* CSVFeed */1 :
          formatValue = "CSV";
          break;
      case /* TSVFeed */2 :
          formatValue = "TSV";
          break;
      case /* CSVFeedNoQuotes */3 :
          formatValue = "CSV (no quotes)";
          break;
      case /* TSVFeedNoQuotes */4 :
          formatValue = "TSV (no quotes)";
          break;
      
    }
    var formatOptions = [
      {
        title: "CSV",
        value: "CSV",
        group: undefined
      },
      {
        title: "TSV",
        value: "TSV",
        group: undefined
      },
      {
        title: "CSV (no quotes)",
        value: "CSV (no quotes)",
        group: undefined
      },
      {
        title: "TSV (no quotes)",
        value: "TSV (no quotes)",
        group: undefined
      },
      {
        title: "XML",
        value: "XML",
        group: undefined
      }
    ];
    var onChangeUrl = function (value) {
      setCurrencySettings(function (param) {
            var tmp;
            switch (param[1].TAG | 0) {
              case /* XMLFeed */0 :
                  tmp = {
                    TAG: /* XMLFeed */0,
                    _0: value
                  };
                  break;
              case /* CSVFeed */1 :
                  tmp = {
                    TAG: /* CSVFeed */1,
                    _0: value
                  };
                  break;
              case /* TSVFeed */2 :
                  tmp = {
                    TAG: /* TSVFeed */2,
                    _0: value
                  };
                  break;
              case /* CSVFeedNoQuotes */3 :
                  tmp = {
                    TAG: /* CSVFeedNoQuotes */3,
                    _0: value
                  };
                  break;
              case /* TSVFeedNoQuotes */4 :
                  tmp = {
                    TAG: /* TSVFeedNoQuotes */4,
                    _0: value
                  };
                  break;
              
            }
            return [
                    param[0],
                    tmp
                  ];
          });
    };
    var onChangeFormat = function (value) {
      setCurrencySettings(function (param) {
            var tmp;
            switch (value) {
              case "CSV" :
                  tmp = {
                    TAG: /* CSVFeed */1,
                    _0: url
                  };
                  break;
              case "CSV (no quotes)" :
                  tmp = {
                    TAG: /* CSVFeedNoQuotes */3,
                    _0: url
                  };
                  break;
              case "TSV" :
                  tmp = {
                    TAG: /* TSVFeed */2,
                    _0: url
                  };
                  break;
              case "TSV (no quotes)" :
                  tmp = {
                    TAG: /* TSVFeedNoQuotes */4,
                    _0: url
                  };
                  break;
              case "XML" :
                  tmp = {
                    TAG: /* XMLFeed */0,
                    _0: url
                  };
                  break;
              default:
                tmp = {
                  TAG: /* CSVFeed */1,
                  _0: url
                };
            }
            return [
                    param[0],
                    tmp
                  ];
          });
    };
    var onChangeCurrency = function (value) {
      setCurrencySettings(function (param) {
            return [
                    value.toUpperCase(),
                    param[1]
                  ];
          });
    };
    var onClickDelete = function (param) {
      Curry._1(setSettings, (function (current) {
              return {
                      userId: current.userId,
                      supplementaryFeed: current.supplementaryFeed,
                      currencies: Belt_Array.concatMany([
                            getCurrencies(current).slice(0, index),
                            getCurrencies(current).slice(index + 1 | 0)
                          ]),
                      autoSync: current.autoSync
                    };
            }));
    };
    return React.createElement("div", {
                className: CSS$MakerDs.prefix("flex space-x-2")
              }, React.createElement("div", {
                    className: CSS$MakerDs.prefix("flex-grow")
                  }, React.createElement(Input$MakerDs.make, {
                        label: "Product feed URL",
                        placeholder: "https://example.com/feed.csv",
                        value: url,
                        onChange: onChangeUrl
                      })), React.createElement("div", {
                    className: CSS$MakerDs.prefix("w-16")
                  }, React.createElement(Select$MakerDs.make, {
                        label: "Format",
                        value: formatValue,
                        options: formatOptions,
                        onChange: onChangeFormat
                      })), React.createElement("div", {
                    className: CSS$MakerDs.prefix("w-16")
                  }, React.createElement(Input$MakerDs.make, {
                        label: "Currency",
                        placeholder: "USD",
                        value: currency,
                        onChange: onChangeCurrency
                      })), React.createElement("div", {
                    className: CSS$MakerDs.prefix("w-16 pt-8")
                  }, index > 0 ? React.createElement(Button$MakerDs.make, {
                          onClick: onClickDelete,
                          outline: true,
                          disabled: saveDisabled,
                          size: 8,
                          text: "X"
                        }) : null));
  };
  React.useEffect((function () {
          console.log("settings", settings);
        }), [JSON.stringify(settings)]);
  var onClickAddCurrency = function (param) {
    Curry._1(setSettings, (function (current) {
            return {
                    userId: current.userId,
                    supplementaryFeed: current.supplementaryFeed,
                    currencies: Belt_Array.concat(getCurrencies(current), [[
                            "",
                            {
                              TAG: /* CSVFeed */1,
                              _0: ""
                            }
                          ]]),
                    autoSync: current.autoSync
                  };
          }));
  };
  var match$1 = settings.autoSync;
  var tmp;
  switch (match$1) {
    case /* Disabled */0 :
        tmp = "disabled";
        break;
    case /* Hourly */1 :
        tmp = "1hour";
        break;
    case /* SixHours */2 :
        tmp = "6hours";
        break;
    case /* TwelveHours */3 :
        tmp = "12hours";
        break;
    
  }
  return React.createElement("div", {
              className: CSS$MakerDs.prefix("")
            }, React.createElement(Form$MakerDs.make, {
                  title: "Settings",
                  description: "Connect and sync your product feed with Maker.",
                  onSubmitAsync: onSubmitAsync,
                  children: null,
                  submitText: "Save",
                  disabled: saveDisabled
                }, Belt_Array.mapWithIndex(getCurrencies(settings), renderCurrencyFeedSection), React.createElement(Button$MakerDs.make, {
                      onClick: onClickAddCurrency,
                      outline: true,
                      text: "+ Currency"
                    }), React.createElement("div", {
                      className: CSS$MakerDs.prefix("border-t border-gray-100")
                    }, React.createElement("div", {
                          className: CSS$MakerDs.prefix("w-32 pt-6")
                        }, React.createElement(Select$MakerDs.make, {
                              label: "Auto-Sync",
                              value: tmp,
                              options: [
                                {
                                  title: "Off (Manual)",
                                  value: "disabled",
                                  group: undefined
                                },
                                {
                                  title: "Every Hour",
                                  value: "1hour",
                                  group: undefined
                                },
                                {
                                  title: "Every 6 Hours",
                                  value: "6hours",
                                  group: undefined
                                },
                                {
                                  title: "Every 12 Hours",
                                  value: "12hours",
                                  group: undefined
                                }
                              ],
                              onChange: (function (value) {
                                  Curry._1(setSettings, (function (current) {
                                          var tmp;
                                          switch (value) {
                                            case "12hours" :
                                                tmp = /* TwelveHours */3;
                                                break;
                                            case "1hour" :
                                                tmp = /* Hourly */1;
                                                break;
                                            case "6hours" :
                                                tmp = /* SixHours */2;
                                                break;
                                            case "disabled" :
                                                tmp = /* Disabled */0;
                                                break;
                                            default:
                                              tmp = /* Disabled */0;
                                          }
                                          return {
                                                  userId: current.userId,
                                                  supplementaryFeed: current.supplementaryFeed,
                                                  currencies: current.currencies,
                                                  autoSync: tmp
                                                };
                                        }));
                                })
                            })))));
}

var Show = {
  make: SettingsPage$Show
};

function SettingsPage(Props) {
  return React.createElement(Query$MakerDs.make, {
              hook: (function (param) {
                  return ClientAPI$FeedSync.useSettings(undefined);
                }),
              render: (function (settings, mutateSettings) {
                  return React.createElement(Query$MakerDs.make, {
                              hook: (function (param) {
                                  return ClientAPI$FeedSync.useSnapshotHistory(undefined);
                                }),
                              render: (function (snapshotHistory, mutateSnapshotHistory) {
                                  return React.createElement(Layout$FeedSync.make, {
                                              activeNavItem: /* SettingsItem */0,
                                              children: null
                                            }, React.createElement("div", {
                                                  className: CSS$MakerDs.prefix("max-w-3xl")
                                                }, React.createElement(SettingsPage$Show, {
                                                      initialSettings: settings,
                                                      mutateSnapshotHistory: mutateSnapshotHistory,
                                                      mutateSettings: mutateSettings
                                                    })), React.createElement(MonitoringPage$FeedSync.Show.make, {
                                                  settings: settings,
                                                  snapshots: snapshotHistory,
                                                  limit: 3,
                                                  mutate: mutateSnapshotHistory
                                                }));
                                }),
                              fallback: (function (err) {
                                  return React.createElement(ErrorPage$FeedSync.make, {
                                              err: err
                                            });
                                })
                            });
                }),
              fallback: (function (err) {
                  return React.createElement(ErrorPage$FeedSync.make, {
                              err: err
                            });
                })
            });
}

var make = SettingsPage;

export {
  getCurrencies ,
  Show ,
  make ,
}
/* react Not a pure module */
